import "./css/normalize.css"; //CSS reset
import "./css/site.css";

import React from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { TransitionGroup, CSSTransition } from "react-transition-group";

import { PAGE_ROUTES } from "../utils/stateTypes";
import { TERMS, PRIVACY } from "../data/legal";
import Notification from "./notification/Notification";
import ScrollToTop from "./general/ScrollToTop";
import TopNav from "./layout/TopNav";
import Footer from "./layout/Footer";
import Home from "./home/Home";
import Services from "./services/Services";
import LegalPage from "./legal/LegalPage";
import NotFound from "./general/NotFound";

const App = () => {
  let location = useLocation();

  return (
    <React.Fragment>
      <ScrollToTop />
      <TopNav />
      <Notification />
      <TransitionGroup component={null}>
        <CSSTransition
          key={location.pathname}
          classNames={"fade"}
          timeout={300}
        >
          <main className={"site-main"}>
            <Routes location={location}>
              <Route
                path={PAGE_ROUTES.HOME}
                element={<Home />}
              />
              <Route
                path={PAGE_ROUTES.SERVICES}
                element={<Services />}
              />
              <Route
                path={PAGE_ROUTES.TERMS}
                element={<LegalPage page={TERMS} />}
              />
              <Route
                path={PAGE_ROUTES.PRIVACY}
                element={<LegalPage page={PRIVACY} />}
              />
              {/* Old Wix address */}
              <Route
                path={"/privacy-policy-1"}
                element={
                  <Navigate
                    to={PAGE_ROUTES.PRIVACY}
                    replace
                  />
                }
              />
              <Route
                path={"*"}
                element={<NotFound />}
              />
            </Routes>
          </main>
        </CSSTransition>
      </TransitionGroup>
      <Footer />
    </React.Fragment>
  );
};

export default App;
